import type { IngestMode } from '~/components/common/enrichment-run-panel';
import type { AppliedProductFilters } from '~/features/experiments/types/product-metadata.types';

import type { EnrichmentRunConfig } from '../types/enrichment-run-config';
import type {
  ConnectorCode,
  StartScheduledSampleEnrichmentRequest,
} from '../types/scheduled-enrichment.types';

import { getSubBatchSize } from './meta-enrichment-config';

/** What a sample trigger needs to know about the batch. */
export interface SampleTriggerInput {
  connectorCode: ConnectorCode;
  useCase: string;
  scheduledJobId: string;
  subsidiaryId: string;
  syncId?: string | null;
  filters?: AppliedProductFilters | null;
  /** Only an older batch that ran the raw scoring pass has one; the server does not need it. */
  contentScoringWorkflowId?: string | null;
  runConfig: EnrichmentRunConfig;
  overrideCache: boolean;
  ingestMode?: IngestMode | null;
}

/**
 * The sample-enrichment trigger body. One builder for both callers, so they never drift: Start
 * (fires the sample right after the batch is created) and "Generate Sample Content" (the manual
 * retry on the batch). Optional ids and empty filters stay off the wire.
 */
export function sampleTriggerPayload(
  input: SampleTriggerInput,
): StartScheduledSampleEnrichmentRequest {
  return {
    connectorCode: input.connectorCode,
    useCase: input.useCase,
    scheduledJobId: input.scheduledJobId,
    ...(input.syncId ? { syncId: input.syncId } : {}),
    ...(input.filters && Object.keys(input.filters).length > 0 ? { filters: input.filters } : {}),
    ...(input.contentScoringWorkflowId
      ? { contentScoringWorkflowId: input.contentScoringWorkflowId }
      : {}),
    subsidiaryId: input.subsidiaryId,
    sampleSize: getSubBatchSize(10),
    ...input.runConfig,
    overrideCache: input.overrideCache,
    ...(input.ingestMode ? { ingestMode: input.ingestMode } : {}),
  };
}
